import { useState } from "react";
import { Expand, Instagram } from "lucide-react";
import { FadeIn } from "./Reveal";
import Lightbox from "./Lightbox";

const works = [
  { title: "Appartamento Pozzo Strada - Torino", photos: ["/work-11.jpg", "/work-2.jpg", "/work-12.jpg", "/work-13.jpg"] },
  { title: "Appartamento Parella - Torino", photos: ["/work-9.jpg", "/work-18.jpg", "/work-16.jpg", "/work-17.jpg", "/work-14.jpg", "/work-15.jpg", "/work-19.jpg"] },
  { title: "Bagno La Cassa - Torino", photos: ["/work-10.jpg", "/work-20.jpg", "/work-21.jpg", "/work-22.jpg"] },
  { title: "Patio microcemento - Isola d'Elba", photos: ["/work-38.jpg", "/work-39.jpg", "/work-40.jpg", "/work-41.jpg", "/work-42.jpg"] },
  { title: "Appartamento Pozzo Strada 1 - Torino", photos: ["/work-48.jpg", "/work-6.jpg", "/work-25.jpg", "/work-26.jpg", "/work-23.jpg", "/work-24.jpg", "/work-27.jpg"] },
  { title: "Bagno Rivoli - Torino", photos: ["/work-7.jpg", "/work-28.jpg", "/work-29.jpg", "/work-30.jpg", "/work-31.jpg", "/work-32.jpg"] },
  { title: "Finiture decorative", photos: ["/work-46.jpg", "/work-47.jpg"] },
  { title: "Appartamento Venaria - Torino", photos: ["/work-3.jpg", "/work-35.jpg", "/work-33.jpg", "/work-34.jpg", "/work-36.jpg", "/work-37.jpg"] },
  { title: "Bagno Mirafiori Sud - Torino", photos: ["/work-44.jpg", "/work-43.jpg", "/work-45.jpg", "/work-8.jpg"] },
];

export default function Realizzazioni() {
  const [cover, setCover] = useState(null);
  const [photo, setPhoto] = useState(0);

  const open = (i) => {
    setCover(i);
    setPhoto(0);
  };
  const close = () => setCover(null);

  const items =
    cover === null ? [] : works[cover].photos.map((p) => ({ img: p, title: works[cover].title }));

  return (
    <section id="realizzazioni" data-testid="works-section" className="relative bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-28 lg:py-36">
        <FadeIn className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-14 lg:mb-20">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#1C1B1A]"><span className="inline-block border-b border-[#E30613] pb-1">Realizzazioni</span></h2>
          <p className="max-w-xs text-sm leading-relaxed text-[#1C1B1A]/60">
            Questa sezione raccoglie alcune delle nostre principali realizzazioni.
          </p>
        </FadeIn>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-5">
          {works.map((w, i) => (
            <FadeIn key={w.title} delay={(i % 5) * 0.07}>
              <figure
                data-testid={`work-item-${i}`}
                onClick={() => open(i)}
                className="group relative overflow-hidden cursor-zoom-in"
              >
                <div className="relative overflow-hidden">
                  <img
                    src={w.photos[0]}
                    alt={w.title}
                    loading="lazy"
                    className="w-full aspect-[4/5] object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <span className="absolute top-3 right-3 w-7 h-7 rounded-full bg-white shadow-md flex items-center justify-center text-[#1C1B1A] group-hover:bg-[#E30613] group-hover:text-white group-hover:scale-110 transition-[background-color,color,transform] duration-300">
                    <Expand className="w-3.5 h-3.5" strokeWidth={2} />
                  </span>
                  <span
                    data-testid={`work-photo-count-${i}`}
                    className="absolute bottom-3 right-3 rounded-full bg-[#1C1B1A]/80 backdrop-blur-sm px-2.5 py-1 text-[10px] font-bold tracking-wider text-white"
                  >
                    {w.photos.length} {w.photos.length === 1 ? "foto" : "foto"}
                  </span>
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1C1B1A]/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                  <figcaption className="absolute left-0 bottom-0 p-4 pr-20 text-white text-sm font-semibold opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-500">
                    {w.title}
                  </figcaption>
                </div>
              </figure>
            </FadeIn>
          ))}
        </div>
      </div>
      <img src="/fkl-logo.png" alt="" aria-hidden="true" className="absolute bottom-5 right-6 w-16 sm:w-20 pointer-events-none" />
      <a
        href="https://www.instagram.com/fkl.official_"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram FKL"
        data-testid="ig-float-works"
        className="absolute bottom-5 left-6 w-8 h-8 rounded-full bg-[#1C1B1A] flex items-center justify-center text-white hover:bg-[#E30613] hover:scale-110 transition-[background-color,transform] duration-300"
      >
        <Instagram className="w-4 h-4" strokeWidth={1.75} />
      </a>

      <Lightbox
        items={items}
        active={cover === null ? null : photo}
        onClose={close}
        onPrev={() => setPhoto((p) => (p - 1 + items.length) % items.length)}
        onNext={() => setPhoto((p) => (p + 1) % items.length)}
        testidPrefix="lightbox"
      />
    </section>
  );
}
